export default __webpack_public_path__ + "static/media/facility_01_1.676f1da5.png";